import React from 'react';
import { injectIntl } from 'react-intl';
import { Button, Glyphicon } from 'react-bootstrap';
import IntlComponent from 'axway-react-intl';
import { PageHeader } from 'axway-react-ui';

/**
 * Render a page with a PageHeader whose actions handle paging between child components.
 */
class Pager extends React.Component {
	constructor(props) {
		super(props);
		IntlComponent.init(this);

		this.onCancel = this.onCancel.bind(this);
		this.onNext = this.onNext.bind(this);
		this.onPrev = this.onPrev.bind(this);
		this.onSave = this.onSave.bind(this);
		this.onValidate = this.onValidate.bind(this);
		this.state = {
			pageNum: 0,
			isValid: true
		};
	}

	onValidate(isValid) {
		// only set the state when necesarry otherwise we will get an infinite update loop
		if (this.state.isValid !== isValid) {
			this.setState({
				isValid
			});
		}
	}

	onCancel() {
		this.props.onCancel && this.props.onCancel();
	}

	onSave() {
		this.props.onSave && this.props.onSave();
	}

	onPrev() {
		this.setState({
			pageNum: Math.max(this.state.pageNum - 1, 0),
			isValid: true
		});
	}

	onNext() {
		const { children } = this.props;
		this.setState({
			pageNum: Math.min(this.state.pageNum + 1, React.Children.count(children) - 1),
			isValid: true
		});
	}

	render() {
		const { pageNum, isValid } = this.state;
		const { children, title } = this.props;
		const actions = [
			(
				<Button
					key="cancel"
					className="cancel"
					bsSize="large"
					bsStyle="link"
					onClick={this.onCancel}
				>
					<span>{this.intl.formatMsg('Cancel')}</span>
				</Button>
			), (
				<Button
					key="prev"
					className="nav"
					bsSize="large"
					disabled={pageNum === 0}
					onClick={this.onPrev}
				>
					<Glyphicon glyph=" gg icon-GG-chevron-left" />
					<span>{this.intl.formatMsg('Prev')}</span>
				</Button>
			)
		];

		if (pageNum === React.Children.count(children) - 1) {
			actions.push(
				<Button
					key="save"
					className="nav"
					bsSize="large"
					bsStyle="primary"
					disabled={!isValid}
					onClick={this.onSave}
				>
					<Glyphicon glyph=" gg icon-GG-checkmark-circle" />
					<span>{this.intl.formatMsg('Save')}</span>
				</Button>
			);
		} else {
			actions.push(
				<Button
					key="next"
					className="nav"
					bsSize="large"
					bsStyle="primary"
					disabled={!isValid}
					onClick={this.onNext}
				>
					<span>{this.intl.formatMsg('Next')}</span>
					<Glyphicon glyph="right gg icon-GG-chevron-right" />
				</Button>
			);
		}

		return (
			<div className={`pager-view page-${pageNum}`}>
				<PageHeader title={title}>
					<PageHeader.Section align="right">
						{actions}
					</PageHeader.Section>
				</PageHeader>
				{
					React.cloneElement((children)[pageNum], {
						onValidate: this.onValidate
					})
				}
			</div>
		);
	}
}

export default injectIntl(Pager);
